export const AGENT ="Agent:";
export const DATE_OF_SHOOT = "Date of Shoot:";
export const DELIVERY_DATE = "Delivery date:";